import React from 'react';
import {CustomizeItemContext} from '../../CustomizeItemContext';
import WeightSlider from '../WeightSlider';
import Input from './Input';

export default () => {
  const {poolProspectCustomizeItem} = React.useContext(CustomizeItemContext);
  const customizeItemName = poolProspectCustomizeItem?.name;
  return (
    <>
      <div className="flex flex-col gap-4 p-4 bg-white">
        <div className="flex flex-col gap-2 items-start">
          <div className="flex w-full items-center justify-between">
            <div>
              <h2 className="text-base m-0 font-bold">{customizeItemName}</h2>
              <p className="m-0 text-sm">
                {`重要度を高める${customizeItemName}の範囲を設定してください。`}
              </p>
            </div>
            <WeightSlider />
          </div>
          {[1, 2, 3, 4, 5].map((priority) => {
            return <Input key={priority} priority={priority} />;
          })}
        </div>
      </div>
    </>
  );
};